<template>
      <div no-body class="lku-objekpph"> 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><span class="input-group-text">Filter</span></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblObjekpph"
          style="font-size:smaller;" 
          outlined responsive
          striped hover
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          :filter="filter"
          @row-clicked="selectItem"
        >
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 15, 20, 25 , 30, 35, 40, 45, 50]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-objekpph {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import pphpayable from "../../apis/pphpayable";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "jenisphs",
            label: "Kode Objek",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "penghasilan",
            label: "Nama Objek Pajak",
            sortable: true
          },
      ],
      items:[],
      tblData: {
        page: 1,
        total: 0,
        limit:20,
        sortBy: 'jenisphs',
        sortDesc: false
      },
      filter:null
    };
  },
  created: async function() {
      this.data();
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    data: async function(ctx) {
      this.items=await pphpayable.jenispenghasilan();
      this.tblData.total = this.items.length;
      return this.items;      

    },
    selectItem(item,index) {
        this.$emit("click", item);
    },  
    refresh() {
      this.$refs.tblObjekpph.refresh();
    }
  }
};
</script>
